module.exports = __webpack_public_path__ + "static/media/empty-state.e9ff8a50.svg";